var map = {
	"./223.jpg": 550,
	"./262.jpg": 551,
	"./273.jpg": 552,
	"./296.jpg": 553,
	"./322.jpg": 554,
	"./332.jpg": 555,
	"./336.jpg": 556,
	"./338.jpg": 557,
	"./5.jpg": 558,
	"./nalsoft.png": 559,
	"./news2.jpg": 560,
	"./news3.jpg": 561,
	"./news4.jpg": 562,
	"./news5.jpg": 563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 236;